<template>
  <iframe
    ref="iframe"
    sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
    allowfullscreen="true"
    :src="src"
    :style="{
      display: 'block',
      border: 'none'
    }"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import ticket3TicketManagementApi from '@/api/ticket3/ticket-management'

export default {
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters(['currentLang']),
    src() {
      if (!this.currentLang) return ''
      return `https://cms.enterprise.zwiz.app/${this.currentLang}/ticket-edit-iframe`
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    async handleSubmit(value) {
      try {
        this.$store.state.loading = true
        const response = await ticket3TicketManagementApi.putTicketManagement({ data: value })
        if (response.status !== 204) return
        this.$emit('submitted', value)
      } catch (error) {
        console.error(error)
      } finally {
        this.$store.state.loading = false
      }
    },
    handleMessage(event) {
      if (event.source !== this.$refs.iframe.contentWindow) return
      const { event_id, value } = event.data
      switch (event_id) {
        case 'ticket-edit-ready':
          this.$refs.iframe.contentWindow.postMessage(
            {
              event_id: 'ticket-edit-init',
              value: this.value
            },
            '*'
          )
          break
        case 'ticket-edit-submit':
          this.handleSubmit(value)
          break
        case 'ticket-edit-cancel':
          this.$emit('cancel')
          break
        case 'copy_to_clipboard':
          navigator.clipboard.writeText(value)
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/TicketEditIframe.vue